<template>
  <div class="leaves">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Loan Requests</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">Loan</li>
                </ul>
              </div>
              <!-- <div class="col-auto float-right ml-auto">
                <a class="btn add-btn" @click="openDialog"
                  ><i class="fa fa-plus"></i> Request Loan</a
                >
              </div> -->
            </div>
          </div>
          <!-- /Page Header -->
          <!-- Leave Statistics -->
          <div class="row">
            <div class="col-md-3" v-for="item in loanTypes" :key="item.typeId">
              <div class="stats-info">
                <h6>{{ item.description }}</h6>
                <h5>{{ item.tenor }} Months Maximum</h5>
              </div>
            </div>
          </div>
          <!-- /Leave Statistics -->

          <!-- Search Filter -->
          <div class="row filter-row">
            <div class="col-sm-12 col-md-12">
              <div class="form-group form-focus">
                <input
                  type="text"
                  class="form-control floating"
                  v-model="searchParam"
                  style="height: 55px !important"
                />
                <label class="focus-label">Search</label>
              </div>
            </div>
          </div>
          <!-- Search Filter -->

          <!----Datatable-->
          <div class="row">
            <div class="col-md-12">
              <div class="table-responsive">
                <div
                  class="alert alert-danger alert-dismissible fade show"
                  role="alert"
                  v-if="error"
                >
                  <strong>Error!</strong> {{ error }}
                  <button
                    type="button"
                    class="close"
                    data-dismiss="alert"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <v-data-table
                  :headers="headers"
                  :items="sortedLoans"
                  sort-by=""
                  class="elevation-1"
                >
                  <template v-slot:[`item.profile`]="{ item }">
                    <h2 class="table-avatar blue-link">
                      <router-link to="/profile" class="avatar"
                        ><img alt="" src="~@/assets/profiles/avatar-02.jpg"
                      /></router-link>
                      <router-link to="/profile">{{
                        `${item.employee.firstName} ${item.employee.lastName}`
                      }}</router-link>
                    </h2>
                  </template>

                  <template v-slot:[`item.repaymentStartDate`]="{ item }">
                    {{
                      item.repaymentStartDate
                        ? new Date(item.repaymentStartDate).toLocaleDateString()
                        : ""
                    }}
                  </template>
                  <template v-slot:[`item.actions`]="{ item }">
                    <div class="dropdown dropdown-action">
                      <a
                        href="#"
                        class="action-icon dropdown-toggle"
                        data-toggle="dropdown"
                        aria-expanded="false"
                        ><i class="material-icons">more_vert</i></a
                      >
                      <div class="dropdown-menu dropdown-menu-right">
                        <a
                          class="dropdown-item"
                          @click="openDialogStatus(item)"
                          v-if="
                            item.status == 0 &&
                              item.nextApproval == null &&
                              item.approvedBy == null &&
                              user.roles.includes('HRAdmin')
                          "
                          ><i class="fa fa-check"></i> Approve or Reject</a
                        >
                        <router-link
                        class="dropdown-item"
                        :to="{
                          name: 'loanhistory',
                          params: { id: item.employee.id }
                        }"> View History</router-link>
                        <a class="dropdown-item" @click="onDownload(item)" v-if="(item.loanTypeId == 3 || item.loanTypeId == 4) && item.status == 1"
                          ><i class="fa fa-file-o m-r-5"></i> Download Certificate</a
                        >
                        <a
                          class="dropdown-item"
                          @click="updatePayroll(item)"
                          v-if="
                            item.status == 1 &&
                              item.approvedBy != null &&
                              item.updatedByHCRM == null &&
                              (user.roles.includes('HCRM') ||
                                user.roles.includes('TCRM'))
                          "
                          ><i class="fa fa-mark m-r-5"></i> Update Payroll</a
                        >
                      </div>
                    </div>
                  </template>
                  <template v-slot:[`item.stat`]="{ item }">

                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 0 && item.amount != 0 && item.nextApproval"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-purple"></i> Awaiting
                      Manager Approval
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="
                        item.status == 0 &&
                          !item.nextApproval &&
                          !item.approvedBy
                      "
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-purple"></i> Awaiting HR
                      Approval
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 1 && !item.updatedByHCRM"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-success"></i> Awaiting
                      Payroll Update
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 1 && item.updatedByHCRM"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-success"></i> Approved
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 2"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-danger"></i> Declined
                    </a>
                  </template>
                </v-data-table>
              </div>
            </div>
          </div>
          <!---/Datatable-->
          <!-- /Page Content -->
          <!-- Edit Leave Modal -->
          <v-dialog v-model="dialogEdit" max-width="500px">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Edit Loan Request</h5>
                <button type="button" @click="closeEdit">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <form @submit.prevent="updateLoan">
                  <div class="row">
                    <div class="col-md-12">
                      <div
                        class="alert alert-danger alert-dismissible fade show"
                        role="alert"
                        v-if="error"
                      >
                        <strong>Error!</strong> {{ error }}
                        <button
                          type="button"
                          class="close"
                          data-dismiss="alert"
                          aria-label="Close"
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        class="alert alert-success alert-dismissible fade show"
                        role="alert"
                        v-if="message"
                      >
                        <strong>Success!</strong> {{ message }}
                        <button
                          type="button"
                          class="close"
                          data-dismiss="alert"
                          aria-label="Close"
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label>Loan Type <span class="text-danger">*</span></label>
                    <select class="form-control" v-model="loan.loanTypeId" disabled>
                      <option>Select Loan Type</option>
                      <option
                        v-for="item in loanTypes"
                        :key="item.id"
                        :value="item.id"
                      >
                        {{ item.description }}
                      </option>
                    </select>
                  </div>
                  <div class="form-group">
                    <label>Amount <span class="text-danger">*</span></label>
                    <input
                      v-model="loan.amount"
                      class="form-control"
                      type="number"
                    />
                  </div>
                  <div class="form-group">
                    <label
                      >Tenor (per Month)
                      <span class="text-danger">*</span></label
                    >
                    <input
                      v-model="loan.actualTenor"
                      :max="loan.loanType ? loan.loanType.tenor : 0"
                      @change="calculateLoan"
                      class="form-control"
                      type="number"
                    />
                  </div>
                  <div class="form-group" v-if="loan.repaymentAmount > 0">
                    <label
                      >Repayment Amount
                      <span class="text-danger">*</span></label
                    >
                    <input
                      v-model="loan.repaymentAmount"
                      class="form-control"
                      type="number"
                      readonly
                    />
                  </div>
                  <div class="form-group" v-if="loan.repaymentAmount > 0">
                    <label
                      >Repayment Start Date
                      <span class="text-danger">*</span></label
                    >
                    <datepicker
                      v-model="loan.repaymentStartDate"
                      calendar-class
                      input-class
                      bootstrap-styling
                      class="form-control datetimepicker"
                      type="text"
                    />
                  </div>
                  <div class="submit-section" v-if="loan.repaymentAmount > 0">
                    <button class="btn btn-primary submit-btn">Submit</button>
                  </div>
                </form>
              </div>
            </div>
          </v-dialog>
          <!-- /Edit Leave Modal -->
          <!-- Approve Leave Modal -->
          <v-dialog v-model="dialogStatus" max-width="500px">
            <div class="modal-content">
              <div class="modal-body">
                <div class="form-header">
                  <button
                    type="button"
                    class="close"
                    data-dismiss="alert"
                    aria-label="Close"
                    @click="closeStatus"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <h3>Loan Request Approve</h3>
                  <p>Are you sure want to approve for this loan?</p>
                </div>
                <div class="modal-btn delete-action">
                  <div class="row">
                    <div class="col-6">
                      <a
                        @click="changeLoanStatus(1)"
                        class="btn btn-primary continue-btn"
                        >Approve</a
                      >
                    </div>
                    <div class="col-6">
                      <a
                        @click="changeLoanStatus(2)"
                        data-dismiss="modal"
                        class="btn btn-primary cancel-btn"
                        >Decline</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-dialog>
          <!-- /Approve Leave Modal -->
          <!-- Approve Leave Modal -->
          <v-dialog v-model="dialogUpdate" max-width="500px">
            <div class="modal-content">
              <div class="modal-body">
                <div class="form-header">
                  <button
                    type="button"
                    class="close"
                    data-dismiss="alert"
                    aria-label="Close"
                    @click="closeUpdate"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <h3>Loan Request Update</h3>
                  <p>
                    Are you sure want to update employee payroll for this loan?
                  </p>
                </div>
                <div class="modal-btn delete-action">
                  <div class="row">
                    <div class="col-6">
                      <a
                        @click="updateLoanStatus()"
                        class="btn btn-primary continue-btn"
                        >Update</a
                      >
                    </div>
                    <div class="col-6">
                      <a data-dismiss="modal" class="btn btn-primary cancel-btn"
                        >Decline</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-dialog>
          <!-- /Approve Leave Modal -->
          <!-- Delete Leave Modal -->
          <v-dialog v-model="dialogDelete" max-width="500px">
            <div class="modal-content">
              <div class="modal-body">
                <div class="form-header">
                  <button
                    type="button"
                    class="close"
                    data-dismiss="alert"
                    aria-label="Close"
                    @click="closeDelete"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <h3>Delete Loan Request</h3>
                  <p>Are you sure want to delete this loan?</p>
                </div>
                <div class="modal-btn delete-action">
                  <div class="row">
                    <div class="col-6">
                      <a
                        class="btn btn-primary continue-btn"
                        @click="deleteLeave()"
                        data-dismiss="modal"
                        >Delete</a
                      >
                    </div>
                    <div class="col-6">
                      <a
                        href="javascript:void(0);"
                        data-dismiss="modal"
                        class="btn btn-primary cancel-btn"
                        >Cancel</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-dialog>
          <!-- /Delete Leave Modal -->
        </div>
        <!-- /Page Wrapper -->
      </div>
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import Datepicker from "vuejs-datepicker";
import { organizationService } from "@/services/organizationService";
import { employeeService } from "@/services/employeeService";
import { authenticationService } from "@/services/authenticationService";

export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Datepicker
  },
  data() {
    return {
      dialog: false,
      dialogEdit: false,
      dialogStatus: false,
      dialogDelete: false,
      dialogUpdate: false,
      media: "data:image/jpeg;base64,",
      headers: [
        { text: "Employee", value: "profile" },
        { text: "Loan Type", value: "loanType.description" },
        { text: "Amount", value: "amount" },
        { text: "Tenor (per month)", value: "actualTenor" },
        { text: "Repayment Amount", value: "repaymentAmount" },
        { text: "Repayment StartDate", value: "repaymentStartDate" },
        { text: "Status", value: "stat" },
        { text: "Action", value: "actions", sortable: false }
      ],
      loanTypeId: 0,
      amount: 0,
      tenor: 0,
      isManager: false,
      loan: {},
      loans: [],
      loanTypes: [],
      maxTenor: 0,
      company: authenticationService.currentOfficeValue,
      user: authenticationService.currentUserValue,
      error: "",
      message: "",
      status: "",
      searchParam: ""
    };
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    dialogEdit(val) {
      val || this.closeEdit();
    },
    dialogStatus(val) {
      val || this.closeEdit();
    },
    dialogUpdate(val) {
      val || this.closeUpdate();
    },
    tenor(val) {
      if (val > 0 && this.amount > 0 && this.loanTypeId > 0) {
        this.calculateLoan(val);
      }
    },
    loanTypeId(val) {
      var type = this.loanTypes.filter(c => (c.id = val));
      if (type) {
        this.maxTenor = type.tenor;
      } else {
        this.maxTenor = 6;
      }
    }
  },
  computed: {
    sortedLoans: function() {
      function compare(a, b) {
        if (
          new Date(a.requestDate).getTime() < new Date(b.requestDate).getTime()
        )
          return 1;
        if (
          new Date(a.requestDate).getTime() > new Date(b.requestDate).getTime()
        )
          return -1;
        return 0;
      }

      let filteredLoans = this.loans;

      if (this.searchParam !== "") {
        filteredLoans = filteredLoans.filter(l => {
          return (
            l.employee.firstName.toLowerCase().includes(this.searchParam.toLowerCase()) ||
            l.employee.lastName.toLowerCase().includes(this.searchParam.toLowerCase()) ||
            l.loanType.description.toLowerCase().includes(this.searchParam.toLowerCase())
          );
        });
      }
      // return filteredLoans.sort(compare);

      return this.loans ? filteredLoans.sort(compare) : this.loans;
    }
  },

  methods: {
    clearModel() {
      this.amount = 0;
      this.tenor = 0;
      this.loanTypeId = 0;
    },

    close() {
      this.dialog = false;
      this.clearModel();
    },

    openDialog() {
      this.dialog = true;
    },

    closeEdit() {
      this.dialogEdit = false;
    },

    closeStatus() {
      this.dialogStatus = false;
    },

    closeUpdate() {
      this.dialogUpdate = false;
    },

    closeDelete() {
      this.dialogDelete = false;
    },

    setEditLoan(item) {
      this.loan = item;
      this.dialogEdit = true;
      // console.log(`item`, item)
    },
    openDialogStatus(item) {
      this.loan = item;
      this.dialogStatus = true;
      // console.log(`item`, item)
    },
    isEmployeeManager() {
      employeeService.isEmployeeManager().then(model => {
        this.isManager = model;
      });
    },

    setDeleteLoan(item) {
      this.loan = item;
      this.dialogDelete = true;
    },

    deleteLoan() {
      // const id = this.employeeLeaves.id;
      console.log(this.loan.id);
      employeeService.removeLoanRequest(this.loan.id).then(
        id => {
          var unit = JSON.parse(localStorage.getItem("companyUnit"));
          employeeService.getLoanRequestsByUnit(unit.id).then(o => {
            this.loans = o;

            this.dialogDelete = false;
          });
        },
        e => {
          this.error = "Loan is being used in some information";
        }
      );
    },

    setLoan(item) {
      this.loan = item;
    },

    onDownload(loan) {
      this.loading = true
      employeeService.exportCertificate(loan.id, loan.loanTypeId)
      .then(response => {
          let blob = new Blob([response.data], { type: response.data.type });
          // For the processing of the IE browser, CreateObjectURL is not supported by some IE browser
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, response.fileName);
          } else {
            var downloadElement = document.createElement("a");
            var href = window.URL.createObjectURL(blob); // Create a download link
            downloadElement.href = href;
            downloadElement.download = response.fileName; // Download the file name
            document.body.appendChild(downloadElement);
            downloadElement.click(); // click to download
            document.body.removeChild(downloadElement); // Download complete removal element
            window.URL.revokeObjectURL(href); // Release Blob object
          }
          this.loading = false;
        }).catch((error) => {
            alert(error);
            this.loading = false;
        });
    },

    updateLoan() {
      this.submitted = true;
      this.loading = true;
      employeeService.updateLoanRequest(this.loan.id, this.loan).then(
        id => {
          var unit = JSON.parse(localStorage.getItem("companyUnit"));
          employeeService.getLoanRequestsByUnit(unit.id).then(o => {
            this.loans = o;
            this.closeEdit();
          });
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    },

    changeLoanStatus(status) {
      this.submitted = true;
      this.loan.status = status;
      this.loan.approvedBy =
        this.user.employee.firstName + " " + this.user.employee.lastName;
      this.loan.approvedDate = new Date();
      this.loading = true;
      employeeService.updateLoanRequest(this.loan.id, this.loan).then(
        id => {
          var unit = JSON.parse(localStorage.getItem("companyUnit"));
          employeeService.getLoanRequestsByUnit(unit.id).then(o => {
            this.loans = o;
            this.closeStatus();
          });
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    },
    updatePayroll(item) {
      this.loan = item;
      this.dialogUpdate = true;
    },

    updateLoanStatus() {
      this.submitted = true;
      this.loan.updatedByHCRM =
        this.user.employee.firstName + " " + this.user.employee.lastName;
      this.loan.updatedDateByHCRM = new Date();
      this.loading = true;
      employeeService.UpdateLoanToPayroll(this.loan.id, this.loan).then(
        id => {
          var unit = JSON.parse(localStorage.getItem("companyUnit"));
          employeeService.getLoanRequestsByUnit(unit.id).then(o => {
            this.loans = o;
            this.closeUpdate();
          });
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    },
    getLoans() {
      var unit = JSON.parse(localStorage.getItem("companyUnit"));
      employeeService.getLoanRequestsByUnit(unit.id).then(
        o => {
          this.loans = o;
        },
        error => {
          error = error;
        }
      );
    },
    getLoanTypes() {
      employeeService.getLoanTypes(this.company.id).then(
        model => {
          this.loanTypes = model;
          // console.log(model);
        },
        error => {
          error = error;
        }
      );
    },
    onSubmit() {
      this.submitted = true;
      this.loading = true;
      this.loan.requestDate = new Date();
      this.loan.employeeId = this.user.employee.id;
      this.loan.loanType = null;
      employeeService.addLoanRequest(this.loan).then(
        id => {
          this.message = "Loan Request Added successfully";
          employeeService
            .getLoanRequestsByEmployee(this.user.employee.id)
            .then(model => {
              this.loans = model;
              this.message = "";
              this.close();
            });
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    },
    calculateLoan() {
      this.submitted = true;
      this.loading = true;
      employeeService.calculateLoan(this.loan).then(
        model => {
          this.loan.repaymentAmount = model.repaymentAmount;
          this.loan.repaymentStartDate = new Date(
            new Date().getFullYear(),
            new Date().getMonth() + 1,
            new Date().getDate()
          );
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    }
  },
  mounted() {
    this.isEmployeeManager();
    this.getLoanTypes();
    this.getLoans();

    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }

    // Select 2
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%"
      });
    }
    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }
    // Datatable

    // if ($('.datatable').length > 0) {
    //   $('.datatable').DataTable({
    //     "bFilter": false,
    //   });
    // }
    // if ($('.floating').length > 0) {
    //   $('.floating').on('focus blur', function (e) {
    //     $(this).parents('.form-focus').toggleClass('focused', (e.type === 'focus' || this.value.length > 0));
    //   }).trigger('blur');
    // }
  },
  name: "leaves"
};
</script>



// WEBPACK FOOTER //
// src/components/loans/loan/hrLoan.vue